var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-button-block"},[_c('div',{staticClass:"back-button",on:{"click":_vm.clickHandler}},[_c('awesome-icon',{attrs:{"name":"arrow-left","noMargin":""}})],1),_vm._v(" 돌아가기 ")])}
var staticRenderFns = []

export { render, staticRenderFns }